<template>
    <v-card class="ma-4">
        <v-card-title class="text-h5 bg-grey-lighten-2" primary-title>
            Task Groups from References
        </v-card-title>

        <v-card-text>
            <v-data-table
                :headers="taskGroupHeaders"
                :items="taskGroupItems"
                no-results-text="No task groups."
                item-key="id"
                class="elevation-1"
                :items-per-page="10"
            >
            </v-data-table>
        </v-card-text>

        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="cancel"> Cancel </v-btn>
            <v-btn color="primary" @click="save"> Save </v-btn>
        </v-card-actions>
    </v-card>
</template>
<script>
import { defineComponent } from "vue";

import { buildExperimentTaskGroupsAPI } from "@/services/api.services";
import { withLoadingScreen } from "@/lib/loading";
import {
    getDateFromExperimentStartDateForDay,
    getTaskReferenceById,
    getTaskReferenceDisplay,
} from "@/lib/taskUtils";

export default defineComponent({
    props: {
        protocol: {
            type: Object,
            required: true,
        },
        experiment: {
            type: Object,
            required: true,
        },
        taskReferences: {
            type: Array,
            required: true,
        },
    },

    data() {
        return {
            taskGroupItems: [],
            taskGroupHeaders: [
                {
                    title: "Name",
                    value: "name",
                    align: "left",
                    sortable: true,
                    width: "20%",
                },
                {
                    title: "Day",
                    value: "day",
                    align: "left",
                    sortable: true,
                    width: "10%",
                },
                {
                    title: "Reference",
                    value: "referenceDisplayName",
                    align: "left",
                    sortable: false,
                    width: "50%",
                },
                {
                    title: "Date",
                    value: "date",
                    align: "left",
                    sortable: true,
                    width: "10%",
                },
            ],
        };
    },

    mounted() {
        this.taskGroupAPI = buildExperimentTaskGroupsAPI(this.experiment.code);
    },

    methods: {
        updated() {
            withLoadingScreen(async () => {
                const taskGroups = await this.taskGroupAPI.buildTaskGroupsFromTaskReferences();
                this.taskGroupItems = taskGroups.map((taskGroup, index) => {
                    const taskReference = getTaskReferenceById(
                        this.taskReferences,
                        taskGroup.taskReferenceId
                    );
                    const date = getDateFromExperimentStartDateForDay(
                        this.experiment.day0,
                        taskGroup.day
                    );
                    const referenceDisplayName = getTaskReferenceDisplay(
                        taskGroup,
                        taskReference,
                        this.protocol,
                        this.experiment.day0
                    );
                    return {
                        ...taskGroup,
                        taskReference,
                        id: index,
                        name: taskGroup.name,
                        referenceDisplayName: referenceDisplayName,
                        date: date,
                    };
                });
            });
        },
        async save() {
            await withLoadingScreen(async () => {
                const taskGroups = this.taskGroupItems.map((taskGroupItem) => {
                    const taskGroup = {
                        name: taskGroupItem.name,
                        taskReferenceId: taskGroupItem.taskReferenceId,
                        referencedThingId: taskGroupItem.referencedThingId,
                        dayAfterReference: taskGroupItem.dayAfterReference,
                        taskThingDateEstimateId: taskGroupItem.taskThingDateEstimateId,
                    };

                    if (taskGroupItem.taskReference.referenceExperimentStartDate) {
                        // Set the day only if the TaskGroup is based on the experiment start date
                        // Otherwise, the day will be calculated based on the reference date
                        taskGroup.day = taskGroupItem.day;
                    }

                    return taskGroup;
                });
                const savedTaskGroups = await this.taskGroupAPI.bulkSave(taskGroups);
                this.$emit("saved", savedTaskGroups);
            });
        },
        cancel() {
            this.$emit("closed");
        },
        close() {
            this.$emit("closed");
        },
    },
});
</script>
